import {Divider, Layout} from 'antd';
import React from 'react';
import EquationsTabs from './EquationsTabs';

const Equations = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <EquationsTabs/>
      <Divider/>
    </Layout>
  );
};

export default Equations;
